import React from "react";
import ReactDOM from "react-dom";

import { BrowserRouter, Route, Routes,Navigate } from "react-router-dom";

import { Provider } from "react-redux";
import { store } from "./redux/store/store";

import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/page.css';
import "./assets/css/animate.min.css";
import "./assets/sass/light-bootstrap-dashboard.scss?v=1.3.2";
import "./assets/sass/lbd/_datetime-pickers.scss";
import 'font-awesome/css/font-awesome.min.css';
import "./assets/css/pe-icon-7-stroke.css";
// Al final: los tokens y el tema pisan a los estilos heredados.
import './shared/styles/tokens.css';
import './shared/styles/theme.css';
import './shared/styles/themes.css';
import { aplicarTemaDeTablas } from './shared/theme/dataTableTheme';
import ThemeProvider from './shared/theme/ThemeProvider';

import routes from "./routes/app";

aplicarTemaDeTablas();

ReactDOM.render(
  <Provider store={store}>
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          
          {routes.map((item) => (
            <Route
              key={item.path}
              element={<item.component/>}
              path={item.path}
              exact
            />
          ))}
          <Route path="/src" element={<Navigate to="/"></Navigate>}/>
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  </Provider>,
  document.getElementById("root")
);
